import React from 'react';
import { Default } from '../layouts';

const Home = () => <Default>Home</Default>;

export default Home;
